import { Routes } from '@angular/router';

import { AuthDistributorGuard } from '../default/auth/_guards/auth-distributor.guard';
import { AuthGuard } from '../default/auth/_guards/auth.guard';
import { DistributorComponent } from '../default/distributor/distributor.component';
import { AccessGuard } from '../shared/access/access.guard';
import { NoBrandComponent } from '../shared/components/no-brand/no-brand.component';
import { NoContentComponent } from '../shared/components/no-content/no-content.component';
import { CommonConstants } from '../shared/constants/common.constant';
import { BrandGuard } from '../shared/guards/brand.guard';
import { LayoutComponent } from '../shared/layout/layout.component';
import { BcsRenewalResolver } from '@app/default/bcs-renewal/bcs-renewal.resolver';
import { DivisionSelectComponent } from '@app/default/division-select/division-select.component';

export const ROUTES: Routes = [
  {
    path: CommonConstants.appRoutes.login,
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    loadChildren: () => import('../default/auth/auth.module').then(module => module.AuthModule),
    canActivate: [BrandGuard],
  },
  {
    path: '',
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    loadChildren: () => import('../default/auth/auth.module').then(module => module.AuthModule),
    canActivate: [BrandGuard],
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: CommonConstants.appRoutes.settings.settingsBase,
        // eslint-disable-next-line @typescript-eslint/promise-function-async
        loadChildren: () => import('../default/settings/settings.module').then(module => module.SettingsModule),
        canActivate: [AuthGuard, AccessGuard],
      },
      {
        path: CommonConstants.appRoutes.enroll.enrollBase,
        // eslint-disable-next-line @typescript-eslint/promise-function-async
        loadChildren: () => import('../default/employees/employees.module').then(module => module.EmployeesModule),
        canActivate: [AuthGuard, AccessGuard],
      },
      {
        path: CommonConstants.appRoutes.transactions.transactionBase,
        // eslint-disable-next-line @typescript-eslint/promise-function-async
        loadChildren: () => import('../default/transactions/transactions.module').then(module => module.TransactionsModule),
        canActivate: [AuthGuard, AccessGuard],
      },
      {
        path: CommonConstants.appRoutes.files.filesBase,
        // eslint-disable-next-line @typescript-eslint/promise-function-async
        loadChildren: () => import('../default/files/files.module').then(module => module.FilesModule),
        canActivate: [AuthGuard, AccessGuard],
      },
      {
        path: CommonConstants.appRoutes.plan.planBase,
        // eslint-disable-next-line @typescript-eslint/promise-function-async
        loadChildren: () => import('../default/benefit/plans.module').then(module => module.PlansModule),
        canActivate: [AuthGuard, AccessGuard],
      },
      {
        path: CommonConstants.appRoutes.support.supportBase,
        // eslint-disable-next-line @typescript-eslint/promise-function-async
        loadChildren: () => import('../default/support/support.module').then(module => module.SupportModule),
        canActivate: [AuthGuard],
      },
      {
        path: CommonConstants.appRoutes.overview.overviewBase,
        // eslint-disable-next-line @typescript-eslint/promise-function-async
        loadChildren: () => import('../default/overview/overview.module').then(module => module.OverviewModule),
        canActivate: [AuthGuard, AccessGuard],
      },
      {
        path: CommonConstants.appRoutes.reports.reportsBase,
        // eslint-disable-next-line @typescript-eslint/promise-function-async
        loadChildren: () => import('../default/reports/reports.module').then(module => module.ReportsModule),
        canActivate: [AuthGuard, AccessGuard],
      },
      {
        path: CommonConstants.appRoutes.sitemap.sitemapBase,
        // eslint-disable-next-line @typescript-eslint/promise-function-async
        loadChildren: () => import('../default/sitemap/sitemap.module').then(module => module.SitemapModule),
        canActivate: [AuthGuard],
      },
      {
        path: CommonConstants.appRoutes.renew,
        // eslint-disable-next-line @typescript-eslint/promise-function-async
        loadChildren: () => import('../default/bcs-renewal/bcs-renewal.module').then(module => module.BcsRenewalModule),
        canActivate: [AuthGuard],
        resolve: {
          composite: BcsRenewalResolver,
        },
      },
    ],
  },
  {
    path: CommonConstants.appRoutes.distributor,
    component: DistributorComponent,
    data: { title: 'Distributor' },
    canActivate: [AuthDistributorGuard],
  },
  {
    path: CommonConstants.appRoutes.divisionSelect,
    component: DivisionSelectComponent,
    data: { title: 'Division Select' },
    canActivate: [AuthDistributorGuard],
  },
  {
    path: CommonConstants.appRoutes.nobrand,
    component: NoBrandComponent,
  },
  {
    path: '**',
    component: NoContentComponent,
    canActivate: [AuthGuard, AccessGuard],
  },
];
